import { Navigate} from "react-router-dom"


function ProtectedRouteIn({auth, children }) {   
    return auth ? <Navigate to="/dashboard" /> : children ;
   
}
export default ProtectedRouteIn